export default {"src":"/_next/static/media/logo.e7821818.svg","height":25,"width":111,"blurWidth":0,"blurHeight":0};